import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { isDefined } from "@perxis-auto/shared";
import { OverlayView } from "@react-google-maps/api";
import classnames from "../../../../utils/classnames.js";
const Hint = ({ pins, hovered, hintContent, enableHint }) => {
  const hiddenHint = !isDefined(hovered) || !hintContent || !enableHint;
  if (hiddenHint) {
    return null;
  }
  const currentPin = pins.find((m) => m.id === hovered);
  return /* @__PURE__ */ jsx(OverlayView, { mapPaneName: "floatPane", position: { lat: (currentPin == null ? void 0 : currentPin.latitude) ?? 0, lng: (currentPin == null ? void 0 : currentPin.longitude) ?? 0 }, children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-map__hint"), style: { pointerEvents: "none" }, children: hintContent }) });
};
const Hint$1 = memo(Hint);
export {
  Hint$1 as default
};
//# sourceMappingURL=Hint.js.map
